<div class="invoice-modal">
  <div class="modal-header">
    <h5 class="modal-title">Invoice</h5>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-sm-10 mx-auto">
        <!-- <a
        href="https://smarthr.dreamstechnologies.com/html/template/invoices.html"
        class="back-icon d-flex align-items-center fs-12 fw-medium mb-3 d-inline-flex"
      >
        <span class="d-flex justify-content-center align-items-center rounded-circle me-2">
          <i class="ti ti-arrow-left"></i>
        </span>
        Back to List
      </a> -->
        <div id="invoice-print-area" #invoicePrintArea>
          <div class="card">
            <div class="card-body">
              <div class="row justify-content-between align-items-center border-bottom mb-3">
                <div class="col-md-6">
                  <div class="mb-2 w-50">
                    <img src="../../../../assets/img/logo/logo.webp" class="img-fluid" alt="logo" />
                  </div>
                  <p>
                    {{ adminBusinessData.address }}
                    {{ adminBusinessData.city ? ', ' + adminBusinessData.city.name : '' }}
                    {{
                      adminBusinessData.city && adminBusinessData.city.state
                        ? ', ' + adminBusinessData.city.state.name
                        : ''
                    }}
                    {{
                      adminBusinessData.city &&
                      adminBusinessData.city.state &&
                      adminBusinessData.city.country
                        ? ', ' + adminBusinessData.city.country.name
                        : ''
                    }}
                    {{ adminBusinessData.zipCode ? ' - ' + adminBusinessData.zipCode : '' }}
                  </p>
                </div>
                <div class="col-md-6">
                  <div class="text-end mb-3">
                    <h5 class="text-gray mb-1">
                      Invoice No
                      <span class="text-primary">#{{ invoiceData.invoiceDisplayId }}</span>
                    </h5>
                    <p class="mb-1 fw-medium">
                      Date :
                      <span class="text-dark">{{
                        invoiceData.createdAt | date: 'mediumDate'
                      }}</span>
                    </p>
                    <!-- <p class="fw-medium">Due Date : <span class="text-dark">Sep 30, 2023</span></p> -->
                  </div>
                </div>
              </div>
              <div class="row border-bottom mb-3">
                <div class="col-md-5">
                  <p class="text-dark mb-2 fw-semibold">From</p>
                  <div>
                    <h4 class="mb-1">{{ adminBusinessData.legalName }}</h4>
                    <p class="mb-1">
                      {{ adminBusinessData.address }}
                      {{ adminBusinessData.city ? ', ' + adminBusinessData.city.name : '' }}
                      {{
                        adminBusinessData.city && adminBusinessData.city.state
                          ? ', ' + adminBusinessData.city.state.name
                          : ''
                      }}
                      {{
                        adminBusinessData.city &&
                        adminBusinessData.city.state &&
                        adminBusinessData.city.country
                          ? ', ' + adminBusinessData.city.country.name
                          : ''
                      }}
                      {{ adminBusinessData.zipCode ? ' - ' + adminBusinessData.zipCode : '' }}
                    </p>
                    <p class="mb-1">
                      Email :
                      <span class="text-dark"
                        ><a href="javascript:void(0)">{{ adminBusinessData.user?.email }}</a></span
                      >
                    </p>
                    <p>
                      Phone : <span class="text-dark">{{ adminBusinessData.user?.mobile }}</span>
                    </p>
                    <p>
                      GST : <span class="text-dark">{{ adminBusinessData.GST }}</span>
                    </p>
                  </div>
                </div>
                <div class="col-md-5">
                  <p class="text-dark mb-2 fw-semibold">To</p>
                  <div>
                    <h4 class="mb-1">{{ businessData.legalName ?? businessData.businessName }}</h4>
                    <p class="mb-1">
                      {{ businessData.address }}
                      {{ businessData.city ? ', ' + businessData.city.name : '' }}
                      {{
                        businessData.city && businessData.city.state
                          ? ', ' + businessData.city.state.name
                          : ''
                      }}
                      {{
                        businessData.city && businessData.city.state && businessData.city.country
                          ? ', ' + businessData.city.country.name
                          : ''
                      }}
                      {{ businessData.zipCode ? ' - ' + businessData.zipCode : '' }}
                    </p>
                    <p class="mb-1">
                      Email :
                      <span class="text-dark"
                        ><a href="javascript:void(0)">{{ businessData.user?.email ?? '' }}</a></span
                      >
                    </p>
                    <p>
                      Phone : <span class="text-dark">{{ businessData.user?.mobile ?? '' }}</span>
                    </p>
                    <p>
                      GST : <span class="text-dark">{{ businessData.GST }}</span>
                    </p>
                  </div>
                </div>
                <div class="col-md-2 d-none">
                  <div class="mb-3">
                    <p class="text-title mb-2 fw-medium">Payment Status</p>
                    <span class="badge badge-danger align-items-center mb-3"
                      ><i class="ti ti-point-filled"></i>Due in 10 Days</span
                    >
                    <!-- <div>
                  <img
                    src="https://smarthr.dreamstechnologies.com/html/template/assets/img/qr.svg"
                    class="img-fluid"
                    alt="QR"
                  />
                </div> -->
                  </div>
                </div>
              </div>
              <div>
                <!-- <p class="fw-medium">
                Invoice For :
                <span class="text-dark fw-medium">Design & development of Website</span>
              </p> -->
                <div class="table-responsive mb-3">
                  <table class="table">
                    <thead class="thead-light">
                      <tr>
                        <th>Plan</th>
                        <th>Billing Period</th>
                        <th class="text-end">Licence Qty</th>
                        <th class="text-end">Licence Cost</th>
                        <!-- <th class="text-end">Discount</th> -->
                        <th class="text-end">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <h6>{{ subscriptionData.planName }}</h6>
                        </td>
                        <td>
                          {{ invoiceData.createdAt | date: 'mediumDate' }} -
                          {{ invoiceData.nextBillingDate | date: 'mediumDate' }}
                        </td>
                        <td class="text-gray-9 fw-medium text-end">
                          {{
                            invoiceData.licencesChangeCount > 0
                              ? invoiceData.licencesChangeCount
                              : invoiceData.totalLicences
                          }}
                        </td>
                        <td class="text-gray-9 fw-medium text-end">
                          {{ subscriptionData.planCurrencySymbol }}
                          <!-- {{ subscriptionData.priceAfterDiscount }} -->
                          <!-- @if (
                            invoiceData.payments?.[0]?.gatewayResponse?.notes?.context ===
                            'ADD_LICENCES'
                          ) {
                            {{ getLicenceAmount() ?? 'N/A' }}
                          } @else {
                            {{
                              invoiceData.payments?.[0]?.gatewayResponse?.notes?.amount ??
                                invoiceData.amount
                            }}
                          } -->
                          {{ getLicenceAmount() ?? 'N/A' }}
                        </td>
                        <!-- <td class="text-gray-9 fw-medium text-end">
                        {{ subscriptionData.planCurrencySymbol }}
                        {{ subscriptionData.priceAfterDiscount }}
                      </td> -->
                        <td class="text-gray-9 fw-medium text-end">
                          {{ subscriptionData.planCurrencySymbol }}
                          {{
                            invoiceData.payments[0]?.gatewayResponse?.notes?.amount ??
                              invoiceData.amount
                          }}
                        </td>
                      </tr>
                      <!-- <tr>
                      <td><h6>Design System</h6></td>
                      <td class="text-gray-9 fw-medium text-end">1</td>
                      <td class="text-gray-9 fw-medium text-end">$5000</td>
                      <td class="text-gray-9 fw-medium text-end">$100</td>
                      <td class="text-gray-9 fw-medium text-end">$5000</td>
                    </tr>
                    <tr>
                      <td><h6>Brand Guidellines</h6></td>
                      <td class="text-gray-9 fw-medium text-end">1</td>
                      <td class="text-gray-9 fw-medium text-end">$5000</td>
                      <td class="text-gray-9 fw-medium text-end">$100</td>
                      <td class="text-gray-9 fw-medium text-end">$5000</td>
                    </tr>
                    <tr>
                      <td><h6>Social Media Template</h6></td>
                      <td class="text-gray-9 fw-medium text-end">1</td>
                      <td class="text-gray-9 fw-medium text-end">$5000</td>
                      <td class="text-gray-9 fw-medium text-end">$100</td>
                      <td class="text-gray-9 fw-medium text-end">$5000</td>
                    </tr> -->
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row border-bottom mb-3">
                <div class="col-md-7">
                  <div class="py-4">
                    <!-- <div class="mb-3">
                    <h6 class="mb-1">Terms and Conditions</h6>
                    <p>
                      Please pay within 15 days from the date of invoice, overdue interest &#64; 14%
                      will be charged on delayed payments.
                    </p>
                  </div> -->
                    <div class="mb-3">
                      <h6 class="mb-1">Notes</h6>
                      <p>Please quote invoice number when remitting funds.</p>
                      <p>This is auto-generated by the system.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-5">
                  <div
                    class="d-flex justify-content-between align-items-center border-bottom mb-2 pe-3"
                  >
                    <p class="mb-0">Sub Total</p>
                    <p class="text-dark fw-medium mb-2">
                      {{ subscriptionData.planCurrencySymbol }}
                      {{
                        invoiceData.payments[0]?.gatewayResponse?.notes?.amount ??
                          invoiceData.amount
                      }}
                    </p>
                  </div>
                  <div *ngIf="invoiceData.payments?.[0] as payment">
                    <!-- Coupon -->
                    <div
                      *ngIf="(payment.gatewayResponse?.notes?.couponDiscount ?? 0) > 0"
                      class="d-flex justify-content-between align-items-center border-bottom mb-2 pe-3"
                    >
                      <p class="mb-0">Coupon Discount</p>
                      <p class="text-dark fw-medium mb-2">
                        {{ subscriptionData.planCurrencySymbol }}
                        {{ payment.gatewayResponse?.notes?.couponDiscount }}
                      </p>
                    </div>

                    <!-- Taxable Amount -->
                    <div
                      class="d-flex justify-content-between align-items-center border-bottom mb-2 pe-3"
                      *ngIf="(payment.gatewayResponse?.notes?.couponDiscount ?? 0) > 0"
                    >
                      <p class="mb-0">Taxable Amount</p>
                      <p class="text-dark fw-medium mb-2">
                        {{ subscriptionData.planCurrencySymbol }}
                        {{ payment.gatewayResponse.notes.taxableAmount ?? payment.taxableAmount }}
                      </p>
                    </div>

                    <!-- GST -->
                    <div *ngIf="+payment.gstAmount > 0" class="border-bottom py-2 pe-3">
                      <div class="d-flex justify-content-between align-items-center fw-semibold">
                        <p class="mb-0">GST ({{ payment.gstRate }}%)</p>
                        <p class="mb-0">
                          {{ subscriptionData.planCurrencySymbol }}
                          {{ payment.gstAmount }}
                        </p>
                      </div>

                      <!-- CGST -->
                      <div
                        *ngIf="+payment.cgst > 0"
                        class="d-flex justify-content-between align-items-center ps-4 mt-2 text-muted"
                      >
                        <small>CGST ({{ halfGstRate }}%)</small>
                        <small>
                          {{ subscriptionData.planCurrencySymbol }}
                          {{ payment.cgst }}
                        </small>
                      </div>

                      <!-- SGST -->
                      <div
                        *ngIf="+payment.sgst > 0"
                        class="d-flex justify-content-between align-items-center ps-4 mt-1 text-muted"
                      >
                        <small>SGST ({{ halfGstRate }}%)</small>
                        <small>
                          {{ subscriptionData.planCurrencySymbol }}
                          {{ payment.sgst }}
                        </small>
                      </div>

                      <!-- IGST -->
                      <div
                        *ngIf="+payment.igst > 0"
                        class="d-flex justify-content-between align-items-center ps-4 mt-1 text-muted"
                      >
                        <small>IGST ({{ payment.gstRate }}%)</small>
                        <small>
                          {{ subscriptionData.planCurrencySymbol }}
                          {{ payment.igst }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="d-flex justify-content-between align-items-center mb-2 pe-3">
                    <h5>Total Amount</h5>
                    <h5>
                      {{ subscriptionData.planCurrencySymbol }}
                      {{
                        invoiceData.chargeAmount ?? invoiceData.amount ?? invoiceData.planTotalCost
                      }}
                    </h5>
                  </div>
                  <p class="fs-12">
                    Amount in Words :
                    {{
                      invoiceData.chargeAmount ?? invoiceData.amount ?? invoiceData.planTotalCost
                        | numberToWords
                    }}
                  </p>
                </div>
              </div>
              <!-- <div class="row justify-content-end align-items-end text-end border-bottom mb-3">
              <div class="col-md-3">
                <div class="text-end">
                  <img
                    src="https://smarthr.dreamstechnologies.com/html/template/assets/img/sign.svg"
                    class="img-fluid"
                    alt="sign"
                  />
                </div>
                <div class="text-end mb-3">
                  <h6 class="fs-14 fw-medium pe-3">Ted M. Davis</h6>
                  <p>Assistant Manager</p>
                </div>
              </div>
            </div> -->

              <div class="text-center border-bottom mb-3">
                <p class="text-dark mb-1">
                  Payment Made Via bank transfer / Cheque in the name of
                  {{ adminBusinessData.legalName }}
                </p>
                <div class="d-flex justify-content-center align-items-center">
                  <p class="fs-12 mb-0 me-3">
                    Bank Name : <span class="text-dark">HDFC Bank</span>
                  </p>
                  <p class="fs-12 mb-0 me-3">
                    Account Number : <span class="text-dark">45366287987</span>
                  </p>
                  <p class="fs-12">IFSC : <span class="text-dark">HDFC0018159</span></p>
                </div>
              </div>
              <div class="text-center">
                <div class="mb-3 w-25 mx-auto">
                  <img src="../../../../assets/img/logo/logo.webp" class="img-fluid" alt="logo" />
                </div>
                <!-- <p class="text-dark mb-1">
                Payment Made Via bank transfer / Cheque in the name of
                {{ adminBusinessData.legalName }}
              </p>
              <div class="d-flex justify-content-center align-items-center">
                <p class="fs-12 mb-0 me-3">Bank Name : <span class="text-dark">HDFC Bank</span></p>
                <p class="fs-12 mb-0 me-3">
                  Account Number : <span class="text-dark">45366287987</span>
                </p>
                <p class="fs-12">IFSC : <span class="text-dark">HDFC0018159</span></p>
              </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center align-items-center mb-4">
          <a
            href="javascript:void(0)"
            class="btn btn-primary d-flex justify-content-center align-items-center me-2"
            (click)="printInvoice()"
            ><i class="ti ti-printer me-2"></i>Print</a
          >
          <button
            href="javascript:void(0)"
            class="btn btn-white d-flex justify-content-center align-items-center border"
            (click)="downloadInvoice()"
            [disabled]="isDownloading"
          >
            <!-- <i class="ti ti-download me-2"></i>Download Invoice</a -->
            <!-- > -->
            <span *ngIf="isDownloading" class="spinner-border spinner-border-sm me-1"></span>
            <i *ngIf="!isDownloading" class="ti ti-download me-1"></i>
            {{ isDownloading ? 'Generating...' : 'Download' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
